var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 5.33333V9.33333C14.6666 10.0667 14.0666 10.6667 13.3333 10.6667H12.6666V9.33333H13.3333V5.33333H2.66659V9.33333H6.66659V10.6667H2.66659C1.93325 10.6667 1.33325 10.0667 1.33325 9.33333V5.33333C1.33325 4.6 1.93325 4 2.66659 4H13.3333C14.0666 4 14.6666 4.6 14.6666 5.33333ZM9.66659 12L10.3933 10.3933L11.9999 9.66667L10.3933 8.94L9.66659 7.33333L8.93992 8.94L7.33325 9.66667L8.93992 10.3933L9.66659 12ZM11.3333 8.66667L11.7466 7.74667L12.6666 7.33333L11.7466 6.92L11.3333 6L10.9199 6.92L9.99992 7.33333L10.9199 7.74667L11.3333 8.66667ZM9.66659 12L10.3933 10.3933L11.9999 9.66667L10.3933 8.94L9.66659 7.33333L8.93992 8.94L7.33325 9.66667L8.93992 10.3933L9.66659 12ZM11.3333 8.66667L11.7466 7.74667L12.6666 7.33333L11.7466 6.92L11.3333 6L10.9199 6.92L9.99992 7.33333L10.9199 7.74667L11.3333 8.66667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaIcon);
export default __webpack_public_path__ + "static/media/cta-icon.fe52cd021f485d9bf05dd311a6478f16.svg";
export { ForwardRef as ReactComponent };